import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { ReportPreferenceDto } from './dtos/report-preference.dto';
import { ReportPreferenceMapper } from './mappers/report-preference.mapper';
import { ReportPreference } from '@ps/user-settings-models';

@Injectable({ providedIn: 'root' })
export class ReportPreferenceApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);
  private readonly _baseUrl = this._env.pureSpectrum.url;

  private readonly _mapper = new ReportPreferenceMapper();

  public getReportPreference(userId: number): Observable<ReportPreference[]> {
    return this._http
      .get<
        ReportPreferenceDto[]
      >(`${this._baseUrl}/reports/users/${userId}/preferences`)
      .pipe(map((data) => this._mapper.fromDtoList(data)));
  }

  public saveReportPreference(
    userId: number,
    reportPreferences: ReportPreference[],
  ): Observable<number[]> {
    const preferences = reportPreferences
      .filter((pref) => pref.selected)
      .map((preference) => preference.id);

    return this._http.post<number[]>(
      `${this._baseUrl}/reports/users/${userId}/preferences`,
      { preferences },
    );
  }
}
